import styled, {css } from 'styled-components';
import {theme } from '../../styles/theme';

export const AdminLayout = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f4f7f6;
`;

export const AdminSidebar = styled.nav`
  width: 250px;
  background-color: #2c3e50;
  color: white;
  padding: 20px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  h2 {
    text-align: center;
    margin-bottom: 30px;
    color: #ecf0f1;
  }
  ul {
    list-style: none;
    padding: 0;
    li {
      padding: 12px 15px;
      margin-bottom: 10px;
      cursor: pointer;
      border-radius: 5px;
      transition: background-color 0.2s ease;
      &:hover {
        background-color: #34495e;
      }
      &.active {
        background-color: #3498db;
        font-weight: bold;
      }
    }
  }
`;

export const MainContent = styled.div`
  flex-grow: 1;
  padding: 30px;
  overflow-y: auto;
`;
export const UserInfo = styled.div`
  background-color: #34495e;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 25px;
`;

export const SidebarList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
`;

export const SidebarItem = styled.li`
  padding: 12px 15px;
  margin-bottom: 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #34495e;
  }
  
  &.active {
    background-color: #3498db;
    font-weight: bold;
  }
`;

export const LogoutButton = styled.button`
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 12px 15px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: auto;
  font-weight: bold;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #c0392b;
  }
`;

export const Button = styled.button`
  padding: 0.75rem 1.5rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #2980b9;
  }
`;
export const InactivityWarning = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const CountdownTimer = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: #e74c3c;
  margin: 1rem 0;
  padding: 0.5rem;
  border: 2px solid #e74c3c;
  border-radius: 4px;
  background-color: #fff;
`;
export const SidebarHeader = styled.div`
  margin-bottom: 30px;
  
  h2 {
    margin: 0;
    color: #ecf0f1;
    font-size: 1.5rem;
  }
`;

export const AdminHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
`;

export const AdminTitle = styled.h1`
  font-size: 2em;
  color: #333;
`;

export const AdminContent = styled.div`
  background-color: #ffffff;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
`;

export const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

export const StatCard = styled.div`
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  text-align: center;
  h3 {
    margin-top: 0;
    color: #555;
    font-size: 1.1em;
  }
  p {
    font-size: 2em;
    font-weight: bold;
    color: #3498db;
    margin-bottom: 0;
  }

  &.pending {
    border-left: 5px solid #ffc107;
    p {color: #ffc107; }
  }
  &.approved {
    border-left: 5px solid #28a745;
    p {color: #28a745; }
  }
  &.rejected {
    border-left: 5px solid #dc3545;
    p {color: #dc3545; }
  }
  &.banned {
    border-left: 5px solid #dc3545;
    p {color: #dc3545; }
  }
  &.suspended {
    border-left: 5px solid #6c757d;
    p {color: #6c757d; }
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  align-items: center;

  select {
    padding: 10px 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: white;
    font-size: 1em;
  }
`;

export const SearchBar = styled.input`
  flex-grow: 1;
  padding: 10px 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1em;
`;

const TableStyles = css`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
`;

export const UserTable = styled.table`
  ${TableStyles}
`;

export const EstateTable = styled.table`
  ${TableStyles}
`;

export const TableHeader = styled.th`
  background-color: #f2f2f2;
  padding: 12px 15px;
  text-align: left;
  font-weight: bold;
  color: #555;
  border-bottom: 1px solid #ddd;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }
  &:hover {
    background-color: #f1f1f1;
  }
`;

export const TableCell = styled.td`
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  color: #333;
`;

export const StatusBadge = styled.span<{status: string }>`
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.85em;
  font-weight: bold;
  color: white;

  ${props => props.status === 'pending' && css`
    background-color: #ffc107;
  `}
  ${props => props.status === 'approved' && css`
    background-color: #28a745;
  `}
  ${props => props.status === 'rejected' && css`
    background-color: #dc3545;
  `}
  ${props => props.status === 'banned' && css`
    background-color: #dc3545;
  `}
  ${props => props.status === 'suspended' && css`
    background-color: #6c757d;
  `}
  ${props => props.status === 'available' && css`
    background-color: #28a745;
  `}
  ${props => props.status === 'sold' && css`
    background-color: #dc3545;
  `}
  ${props => props.status === 'pending' && css`
    background-color: #ffc107;
  `}
`;

export const ActionButton = styled.button`
  padding: 8px 12px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.2s ease;
  white-space: nowrap;

  &:not(:last-child) {
    margin-right: 8px;
  }

  &.approve, &.primary {
    background-color: #3498db;
    color: white;
    &:hover {
      background-color: #2980b9;
    }
  }

  &.reject {
    background-color: #dc3545;
    color: white;
    &:hover {
      background-color: #c82333;
    }
  }
  &.delete {
    background-color: #dc3545;
    color: white;
    &:hover {
      background-color: #c82333;
    }
  }

  &.ban {
    background-color: #dc3545;
    color: white;
    &:hover {
      background-color: #c82333;
    }
  }

  &.suspend {
    background-color: #ffc107;
    color: #333;
    &:hover {
      background-color: #e0a800;
    }
  }

  &.cancel {
    background-color: #6c757d;
    color: white;
    &:hover {
      background-color: #5a6268;
    }
  }

  &.edit {
    background-color: #17a2b8;
    color: white;
    &:hover {
      background-color: #138496;
    }
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
  gap: 10px;

  button {
    padding: 8px 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
    font-size: 1em;
    &:hover:not(:disabled) {
      background-color: #f0f0f0;
    }
    &:disabled {
      color: #ccc;
      cursor: not-allowed;
    }
  }
  span {
    font-size: 1em;
    color: #555;
  }
`;

export const LoadingSpinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 50px auto;

  @keyframes spin {
    0% {transform: rotate(0deg); }
    100% {transform: rotate(360deg); }
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  max-width: 90%;
  width: 800px; /* Specific width for a larger modal */
  max-height: 90vh; /* Allow scrolling if content is too long */
  overflow-y: auto; /* Enable scrolling for content */
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  h3 {
    margin: 0;
    color: #333;
    font-size: 1.5em;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;

  button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1em;
    transition: background-color 0.2s ease;

    &.cancel {
      background-color: #6c757d;
      color: white;
      &:hover {
        background-color: #5a6268;
      }
    }
    &.primary {
      background-color: #3498db;
      color: white;
      &:hover {
        background-color: #2980b9;
      }
    }
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;

export const FormContainer = styled.div`
  flex-grow: 1;
  form {
    display: grid;
    grid-template-columns: 1fr; /* Default to single column */
    gap: 20px;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 1fr; /* Two columns on larger screens */
    }

    label {
      font-weight: bold;
      margin-bottom: 5px;
      color: #555;
      display: block;
    }

    input[type="text"],
    input[type="number"],
    textarea,
    select {
      width: 100%;
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 5px;
      font-size: 1em;
      box-sizing: border-box;
      &:focus {
        border-color: #3498db;
        outline: none;
        box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
      }
    }

    textarea {
      resize: vertical;
      min-height: 80px;
    }

    .full-width {
      grid-column: 1 / -1; /* Spans all columns */
    }
  }
`;

// Removed MapContainer as it's no longer needed
// export const MapContainer = styled.div`...`;

export const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 10px;

  .file-input-group {
    border: 1px dashed #ccc;
    padding: 15px;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover {
      border-color: #3498db;
    }

    input[type="file"] {
      display: none;
    }

    label {
      cursor: pointer;
      color: #3498db;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }

  .file-previews {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
    margin-top: 10px;

    img, video {
      max-width: 100px;
      max-height: 100px;
      object-fit: cover;
      border-radius: 5px;
      border: 1px solid #eee;
    }
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.85rem 1rem;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 1rem;
  color: #495057;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    outline: none;
  }

  &[type="number"]::-webkit-outer-spin-button,
  &[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;

// Add this new styled component for the map wrapper
export const MapContainerWrapper = styled.div`
  height: 300px; /* Adjust height as needed */
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 6px;
  overflow: hidden; /* Ensures the map stays within bounds */
  margin-top: 0.5rem; /* Space from label */
  margin-bottom: 1rem; /* Space to next input/element */

  .leaflet-container {
    height: 100%;
    width: 100%;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${theme.colors.borderLight};
  border-radius: 4px;
  margin: 10px 0;
  overflow: hidden;

  div {
    height: 100%;
    background-color: ${theme.colors.primary};
    transition: width 0.3s ease;
  }
`;

// Image Preview Container
export const ImagePreviewContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0;
`;

// Preview Item
export const PreviewItem = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px solid ${theme.colors.border};
  border-radius: 4px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

// Delete Button
export const DeleteButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 25px;
  height: 25px;
  background-color: ${theme.colors.danger};
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  line-height: 1;
  z-index: 10;

  &:hover {
    background-color: ${theme.colors.dangerDark};
  }
`;